import { render, staticRenderFns } from "./TheChallengeEvent.vue?vue&type=template&id=5783be22&"
import script from "./TheChallengeEvent.vue?vue&type=script&lang=js&"
export * from "./TheChallengeEvent.vue?vue&type=script&lang=js&"
import style0 from "./TheChallengeEvent.vue?vue&type=style&index=0&id=5783be22&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports